export default __webpack_public_path__ + "static/media/pot_sel.91ac488f.svg";